export const envVars = {
  API_BASE_URL: import.meta.env.VITE_API_URL as string,
} as const;
